import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Spinner from '@components/spinner'
import FilterGroup from '@components/FilterGroup'
import { Dropdown } from '@components/Autocomplete'
import NoContent from '@components/Error/NoContent'
import InfoBox from '@components/InfoBox'
import { StatusFilter } from '@components/StatusFilter'
import RichTextEditor from '@components/RichTextEditor'
import Button from '@components/Button'
import { fireDialog, checkPlaceholderErrors } from './dialogHelpers'
import SendEmails from './SendEmails'

class ExtractEpls extends Component {
  static propTypes = {
    extractEplStore: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    props.extractEplStore.getTemplateOptions()
    this.state = {
      mode: 'preview',
      confirmed: true
    }
  }

  handleSwitch = async mode => {
    const { extractEplStore } = this.props
    if (mode[0] === 'preview') {
      const errorsExist = await checkPlaceholderErrors(
        extractEplStore.selectedTemplate.content
      )
      if (errorsExist) return

      extractEplStore.highlightPlaceholders()
      extractEplStore.generateAndSavePreview()
    } else {
      extractEplStore.placeholders.replace(
        JSON.parse(extractEplStore.selectedTemplate.placeholders)
      )
    }
    this.setState({ mode: mode[0] })
  }

  returnToEplView = () => {
    const { history, extractEplStore } = this.props
    const pathname = history.location.pathname.replace(
      /extract-epls.*/g,
      'experts-pipeline'
    )
    history.push({
      pathname,
      state: { selectedEpls: extractEplStore.selectedEpls.map(epl => epl.id) }
    })
  }

  renderPreview() {
    const { templatePreview, loadingPreview } = this.props.extractEplStore
    if (loadingPreview) return <Spinner />
    return (
      <>
        <FilterGroup label='Subject'>
          <input disabled value={templatePreview.subject} />
        </FilterGroup>
        <FilterGroup label='Content'>
          <RichTextEditor
            readOnly
            skipWrapper
            value={templatePreview.content}
          />
        </FilterGroup>
        <div className='expert-form__section'>
          <Button secondary onClick={() => fireDialog(this.returnToEplView)}>
            Cancel
          </Button>
          <Button
            primary
            onClick={() => {
              this.setState({ confirmed: true })
            }}
          >
            Confirm
          </Button>
        </div>
      </>
    )
  }

  renderTemplate () {
    const { selectedTemplate } = this.props.extractEplStore
    if(!selectedTemplate) return null
    return (
      <div>
        <FilterGroup label='Subject'>
          <input
            value={selectedTemplate.subject}
            onChange={e => {
              this.props.extractEplStore.selectedTemplate.subject =
                e.target.value
            }}
          />
        </FilterGroup>
        <FilterGroup label='Content'>
          <RichTextEditor
            skipWrapper
            value={selectedTemplate.content}
            onChange={val => {
              this.props.extractEplStore.selectedTemplate.content = val
            }}
          />
        </FilterGroup>
        <div className='expert-form__section'>
          <Button secondary onClick={() => fireDialog(this.returnToEplView)}>
            Cancel
          </Button>
          <Button
            secondary
            onClick={() => fireDialog(this.props.extractEplStore.resetTemplate)}
          >
            Reset
          </Button>
          <Button primary onClick={() => this.handleSwitch(['preview'])}>
            Back to preview
          </Button>
        </div>
      </div>
    )
  }

  render () {
    const {
      loading,
      templateOptions,
      selectedTemplateType,
      selectedTemplate,
      selectedEpls,
      placeholders
    } = this.props.extractEplStore

    if (loading) return <Spinner />
    if (!selectedEpls.length) return <NoContent />
    return this.state.confirmed ? (
      <SendEmails
        history={this.props.history}
        returnToPreview={() => {
          this.props.extractEplStore.generateAndSavePreview()
          this.setState({ confirmed: false })
        }}
      />
    ) : (
      <div className='extract-epls flex m-b-xl'>
        <div style={{ width: '100%', marginRight: 20 }}>
          <div className='project-search-bar'>
            <FilterGroup inView label='Select template' labelClass='code-label'>
              <Dropdown
                selectedItem={selectedTemplateType}
                itemToString={item => item && item.name}
                onChange={template => {
                  this.state.mode === 'template'
                    ? fireDialog(() =>
                        this.props.extractEplStore.setTemplate(template)
                      )
                    : this.props.extractEplStore.setTemplate(template)
                }}
                options={templateOptions}
              />
            </FilterGroup>
            {selectedTemplate && (
              <FilterGroup inView label='Select mode' labelClass='code-label'>
                <StatusFilter
                  single
                  required
                  selectedItems={[this.state.mode]}
                  items={['preview', 'template']}
                  onChange={this.handleSwitch}
                />
              </FilterGroup>
            )}
          </div>
          {selectedTemplate && (
            <div>
              {this.state.mode === 'preview'
                ? this.renderPreview()
                : this.renderTemplate()}
            </div>
          )}
        </div>
        {selectedTemplate && (
          <div style={{ width: 400 }}>
            <InfoBox className='placeholders m-t-xxl' icon={null}>
              <h3>Placeholders</h3>
              <div>
                {placeholders.map(pl => (
                  <div key={pl.group} className='m-b-xl'>
                    <label className='code-label'>{pl.group}</label>
                    {pl.placeholders.map(placeholder => (
                      <div
                        key={placeholder}
                        dangerouslySetInnerHTML={{ __html: placeholder }}
                      />
                    ))}
                  </div>
                ))}
                <div className='m-b-xl'>
                  <label>Special</label>
                  <div>
                    {'{{each}}'} - Iterates through an array of EPLs or clients
                  </div>
                  <div>
                    {'{{unless}}'} - Show something if condition is not met
                  </div>
                  <div className='m-b-xl'>
                    <label>Help</label>
                    <div>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://handlebarsjs.com/guide/builtin-helpers.html#unless'
                      >
                        More info
                      </a>
                    </div>
                  </div>
                  <div>
                    <a
                      target='_blank'
                      rel='noopener noreferrer'
                      href='https://atheneum-partners.atlassian.net/servicedesk/customer/portal/8/group/33/create/52'
                    >
                      Ask a question
                    </a>
                  </div>
                </div>
              </div>
            </InfoBox>
          </div>
        )}
      </div>
    )
  }
}

export default inject('extractEplStore')(observer(ExtractEpls))
